import { ArrowRight, ArrowUpRight, ArrowDown } from 'lucide-react';
import { identity } from '../mock';

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative pt-[60px] pb-16 overflow-hidden"
      style={{
        background:
          'linear-gradient(180deg, #F5F0E8 0%, #EDE0CC 45%, #D9986B 85%, #C4622D 100%)',
      }}
    >
      {/* Decorative blob */}
      <svg
        className="absolute -top-32 -right-32 blob-float opacity-70 pointer-events-none"
        width="560" height="560" viewBox="0 0 560 560" aria-hidden="true"
      >
        <defs>
          <radialGradient id="cblob" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FAF6EE" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#FAF6EE" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="280" cy="280" r="240" fill="url(#cblob)" />
      </svg>

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <p className="reveal font-hand text-[26px] md:text-[30px] mb-4" style={{ color: 'var(--terracotta-deep)' }}>
          let&apos;s talk
        </p>
        <h2
          className="reveal reveal-delay-1 font-display leading-[1.02]"
          style={{ fontSize: 'clamp(44px, 8vw, 104px)', color: 'var(--ink)' }}
        >
          Let&apos;s build something
          <span className="italic block" style={{ color: 'var(--terracotta-deep)' }}>great.</span>
        </h2>
        <p className="reveal reveal-delay-2 mt-6 md:mt-8 max-w-2xl text-[16.5px] md:text-[18px] leading-[1.65]" style={{ color: 'var(--ink)' }}>
          Open to full-time product design roles — got a role, or just want to talk design?
        </p>

        <div className="reveal reveal-delay-3 flex flex-wrap gap-3 md:gap-4 mt-9 md:mt-12">
          <a
            href={`mailto:${identity.email}`}
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-[14.5px] tracking-[0.06em] transition-all duration-300"
            style={{ background: 'var(--ink)', color: '#FAF6EE' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#A4501F'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--ink)'; }}
          >
            Get in touch <ArrowRight size={16} />
          </a>
          <a
            href={identity.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-[14.5px] tracking-[0.06em] transition-all duration-300"
            style={{ border: '1.5px solid var(--ink)', color: 'var(--ink)' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(42,31,20,0.06)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            LinkedIn <ArrowUpRight size={16} />
          </a>
          <a
            href={identity.resume}
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full text-[14.5px] tracking-[0.06em] transition-all duration-300"
            style={{ border: '1.5px solid var(--ink)', color: 'var(--ink)' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(42,31,20,0.06)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            Resume <ArrowDown size={16} />
          </a>
        </div>

        <p className="reveal mt-10 text-[14.5px]" style={{ color: 'var(--ink)' }}>
          or say hi at <a href={`mailto:${identity.email}`} className="link-underline" style={{ color: 'var(--ink)' }}>{identity.email}</a>
        </p>
      </div>
    </section>
  );
}
